import React, { useState, useEffect, useContext, useCallback } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
// import Button from '@mui/material/Button';
import { formatDate, formatDate2, formatDate3 } from "../../../common/Common";
import action from "../action";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../context/crmContext";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  // p: 2,
};

const AddDetailsModal = (props) => {
  const {
    isAddModalOpen,
    closeAddModal,
    selectedDetails,
    callListingAPI,
    headerLabel,
    employeeList,
  } = props;
  const { updateUserDetails, addNewUserAPI, getCitiesAPI } = action;
  const [inputDetails, setInput] = useState({
    doctorid: "",
    clinicid: "",
    trainingdatetime: "",
    starttime: "",
    endtime: "",
    training_count: null,
    linkshared: "",
    remarks: "",
    city: null,
    employeeName: "",
    doctorname: "",
    totalprescriptions: 0,
    totalappointments: 0,
    lastprescriptiondate: "",
    lastappointmentdate: "",
    id: null,
    status: "",
    userid: null,
  });
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const [cityList, setCityList] = useState([]);
  const [selectedCity, setSelectedCity] = useState({});
  const {
    user: { id, fname, mname, lname },
    userEmail,
    setSnackBarState,
  } = context;
  const [searchedCity, setSearchedCity] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (selectedDetails) {
      const details = {
        id: selectedDetails.id || null,
        doctorid: selectedDetails.doctorid || "",
        clinicid: selectedDetails.clinicid || "",
        trainingdatetime: selectedDetails.trainingdatetime || "",
        starttime: selectedDetails.starttime || "",
        endtime: selectedDetails.endtime || "",
        training_count: selectedDetails.training_count || "",
        linkshared: selectedDetails.linkshared || "",
        remarks: selectedDetails.remarks || "",
        city: selectedDetails.city || "",
        employeeName:
          `${selectedDetails.fname || fname || ""} ${
            selectedDetails.mname || mname || ""
          } ${selectedDetails.lname || lname || ""}` || "",
        doctorname: selectedDetails.doctorname || "",
        totalprescriptions: selectedDetails.totalprescriptions || "",
        totalappointments: selectedDetails.totalappointments || "",
        lastprescriptiondate:
          formatDate(selectedDetails.lastprescriptiondate) || "",
        lastappointmentdate:
          formatDate(selectedDetails.lastappointmentdate) || "",
        status: selectedDetails.status || "",
        userid: selectedDetails.userid || null,
      };
      setInput(() => details);
    }
  }, []);

  useEffect(() => {
    debouncCityFn(searchedCity);
  }, [searchedCity]);

  const callCityAPI = (value) => {
    const payload = {
      searchtext: value,
    };
    getCitiesAPI(payload, searchCityResponse);
  };

  const searchCityResponse = (response) => {
    setCityList(() => response?.result?.cities);
  };

  const setEditDetails = (value, name) => {
    const details = { ...inputDetails };
    if (
      name === "trainingdatetime" ||
      name === "starttime" ||
      name === "endtime"
    ) {
      details[name] = value;
      setInput(() => details);
    } else {
      details[name] = value;
      setInput(() => details);
    }
  };

  const editDetails = () => {
    if (headerLabel === "Add Details") {
      // alert("hohohohoho");
      const payload = {
        userid: id,
        doctorid: inputDetails.doctorid,
        clinicid: inputDetails.clinicid,
        trainingdatetime: inputDetails.trainingdatetime,
        starttime: inputDetails.starttime,
        endtime: inputDetails.endtime,
        trainingcount: inputDetails.training_count,
        linkshared: inputDetails.linkshared,
        remarks: inputDetails.remarks,
        city: selectedCity.id,
        status: inputDetails.status,
        // userid: inputDetails.userid,
      };
      addNewUserAPI(payload, addedUser);
    } else {
      const payload = {
        id: inputDetails.id,
        trainingdate: inputDetails.trainingdatetime,
        starttime: inputDetails.starttime,
        endtime: inputDetails.endtime,
        trainingcount: inputDetails.training_count,
        linkshared: inputDetails.linkshared,
        remarks: inputDetails.remarks,
        status: inputDetails.status,
        userid: inputDetails.userid,
        // city: inputDetails.city
      };
      updateUserDetails(payload, updatedDetailsDesponse);
    }
  };

  const updatedDetailsDesponse = (details) => {
    context.setSnackBarState({
      isOpen: true,
      message: details.message,
      statusCode: details.statusCode,
    });
    if (details?.statusCode === 200) {
      callListingAPI();
      closeAddModal();
    }
  };

  const addedUser = (details) => {
    context.setSnackBarState({
      isOpen: true,
      message: details.message,
      statusCode: details.statusCode,
    });
    if (details.statusCode === 200) {
      closeAddModal();
      navigate("/dashboard");
    }
  };

  const handleAutocomplete = (e) => {
    setSearchedCity(() => e.target.value);
  };

  const handleSelectedCity = (e, value) => {
    setSelectedCity(() => value);
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 700);
    };
  };

  const handleEmployeeNameChange = (e, value) => {
    const details = { ...inputDetails };
    details.userid = e.target.value;
    setInput(() => details);
  };
  const debouncCityFn = useCallback(debounce(callCityAPI), []);

  return (
    <Modal
      open={isAddModalOpen}
      onClose={closeAddModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {/* <span>Add Details</span> */}
        <Grid container>
          <Grid
            item
            style={{
              backgroundColor: "#f0f1f5",
              width: "100%",
              height: "50px",
            }}
          >
            <p
              style={{
                marginTop: "15px",
                marginLeft: "10px",
                fontFamily: "Lato",
                fontSize: "17px",
                fontWeight: "bold",
                fontStretch: "normal",
                fontStyle: "normal",
                lineHeight: 1,
                letterSpacing: "normal",
                textAlign: "left",
                color: "#333",
              }}
            >
              {headerLabel}
            </p>
          </Grid>
          {/* 1st row */}
          <Grid
            item
            xs={12}
            style={{
              backgroundColor: "white",
              width: "100%",
              display: "inline-flex",
              paddingLeft: "20px",
              paddingTop: "30px",
              flexDirection: "row",
              flexWrap: "wrap",
              position: "relative",
              justifyContent: "center",
              alignContent: "space-between",
              placeContent: "space-between",
            }}
            direction="column"
          >
            {/* <p>bdyewg</p> */}
            <Grid xs={4}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Employee Name
              </InputLabel>
              <FormControl
                variant="standard"
                sx={{ m: 1 }}
                style={{ width: "85%" }}
              >
                {employeeList && employeeList.length ? (
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={inputDetails.userid}
                    onChange={handleEmployeeNameChange}
                  >
                    {employeeList &&
                      employeeList.length &&
                      employeeList.map((e) => (
                        <MenuItem value={e.userid}>{e.name}</MenuItem>
                      ))}
                  </Select>
                ) : (
                  <TextField
                    className="login-input"
                    id="outlined-start-adornment"
                    size="small"
                    value={inputDetails.employeeName}
                    disabled
                  />
                )}
              </FormControl>
            </Grid>
            <Grid xs={4}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Doctor ID
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  // error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  size="small"
                  value={inputDetails.doctorid}
                  disabled
                  // sx={{ width: "50ch" }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <img height="24px" width="24px" src={emailIcon} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  // onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid xs={4}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Cinic ID
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  // error={!isUserNameValid}
                  size="small"
                  className="login-input"
                  id="outlined-start-adornment"
                  value={inputDetails.clinicid}
                  disabled
                  // sx={{ width: "50ch" }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <img height="24px" width="24px" src={emailIcon} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  // onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
            </Grid>
          </Grid>
          {/* 2nd row */}
          <Grid
            item
            xs={12}
            style={{
              backgroundColor: "white",
              width: "100%",
              display: "inline-flex",
              padding: "10px",
              paddingLeft: "20px",
              flexDirection: "row",
              flexWrap: "wrap",
              position: "relative",
              justifyContent: "center",
              alignContent: "space-between",
              placeContent: "space-between",
              paddingTop: "0px",
            }}
            direction="column"
          >
            <Grid xs={4}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Doctor Name
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  // error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  size="small"
                  value={inputDetails.doctorname}
                  disabled
                  // sx={{ width: "50ch" }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <img height="24px" width="24px" src={emailIcon} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  // onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid xs={4}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Training Date
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  error={false}
                  className="login-input"
                  id="outlined-start-adornment"
                  size="small"
                  type="datetime-local"
                  value={inputDetails.trainingdatetime}
                  defaultValue={inputDetails.trainingdatetime}
                  onChange={(e) =>
                    setEditDetails(e.target.value, "trainingdatetime")
                  }
                  sx={{ width: "25ch" }}
                  InputProps={{
                    sx: {
                      color: "black",
                    },
                  }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <img height="24px" width="24px" src={emailIcon} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  // onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid xs={4} style={{ paddingLeft: "7px" }}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Start Time
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  // error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  size="small"
                  type="datetime-local"
                  value={inputDetails.starttime}
                  defaultValue={inputDetails.starttime}
                  onChange={(e) => setEditDetails(e.target.value, "starttime")}
                  sx={{ width: "24ch" }}
                  InputProps={{
                    sx: {
                      color: "black",
                    },
                  }}
                  // sx={{ width: "50ch" }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <img height="24px" width="24px" src={emailIcon} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  // onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
            </Grid>
          </Grid>
          {/* 3rd row */}
          <Grid
            item
            xs={12}
            style={{
              backgroundColor: "white",
              width: "100%",
              display: "inline-flex",
              padding: "10px",
              paddingLeft: "20px",
              flexDirection: "row",
              flexWrap: "wrap",
              position: "relative",
              justifyContent: "center",
              alignContent: "space-between",
              placeContent: "space-between",
              paddingTop: "0px",
            }}
            direction="column"
          >
            {/* <p>bdyewg</p> */}
            <Grid xs={4}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Total Training Counts
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  // error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  size="small"
                  type="number"
                  value={inputDetails.training_count}
                  onChange={(e) =>
                    setEditDetails(e.target.value, "training_count")
                  }
                  disabled
                  // sx={{ width: "50ch" }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <img height="24px" width="24px" src={emailIcon} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  // onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid xs={8}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Link Shared
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  // error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  sx={{ width: "52.5ch" }}
                  size="small"
                  value={inputDetails.linkshared}
                  onChange={(e) => setEditDetails(e.target.value, "linkshared")}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <img height="24px" width="24px" src={emailIcon} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  // onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
            </Grid>
          </Grid>
          {/* 4th row */}
          <Grid
            item
            xs={12}
            style={{
              backgroundColor: "white",
              width: "100%",
              display: "inline-flex",
              padding: "10px",
              paddingLeft: "20px",
              flexDirection: "row",
              flexWrap: "wrap",
              position: "relative",
              justifyContent: "center",
              alignContent: "space-between",
              placeContent: "space-between",
            }}
            direction="column"
          >
            {/* <p>bdyewg</p> */}
            <Grid xs={4}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Total Prescription
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  // error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  size="small"
                  value={inputDetails.totalprescriptions}
                  disabled
                  // sx={{ width: "50ch" }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <img height="24px" width="24px" src={emailIcon} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  // onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid xs={4}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Total Appointments
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  // error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  size="small"
                  value={inputDetails.totalappointments}
                  disabled
                  // sx={{ width: "50ch" }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <img height="24px" width="24px" src={emailIcon} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  // onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid xs={4} style={{ paddingLeft: "7px" }}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Last Prescription
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  // error={!isUserNameValid}
                  size="small"
                  className="login-input"
                  id="outlined-start-adornment"
                  value={inputDetails.lastprescriptiondate}
                  disabled
                  // sx={{ width: "50ch" }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <img height="24px" width="24px" src={emailIcon} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  // onChange={(e) => getUserName(e.target.value)}
                />
              </FormControl>
            </Grid>
          </Grid>
          {/* 5th row */}

          <Grid
            item
            xs={12}
            style={{
              backgroundColor: "white",
              width: "100%",
              display: "inline-flex",
              padding: "10px",
              paddingLeft: "20px",
              flexDirection: "row",
              flexWrap: "wrap",
              position: "relative",
              justifyContent: "center",
              alignContent: "space-between",
              placeContent: "space-between",
              paddingTop: "0px",
            }}
            direction="column"
          >
            <Grid xs={4}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                End Time
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  // error={!isUserNameValid}
                  className="login-input"
                  id="outlined-start-adornment"
                  size="small"
                  type="datetime-local"
                  value={inputDetails.endtime}
                  defaultValue={inputDetails.endtime}
                  sx={{ width: "24ch" }}
                  onChange={(e) => setEditDetails(e.target.value, "endtime")}
                  InputProps={{
                    sx: {
                      color: "black",
                    },
                  }}
                />
              </FormControl>
            </Grid>
            <Grid xs={4} style={{ paddingLeft: "7px" }}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                City
              </InputLabel>
              <Autocomplete
                disablePortal
                open={open}
                onOpen={() => setOpen(() => true)}
                onClose={() => setOpen(() => false)}
                id="combo-box-demo"
                disableClearable
                options={cityList}
                value={selectedCity.name || inputDetails.city || ""}
                freeSolo
                defaultValue={selectedCity.name}
                filterOptions={(x) => x}
                renderOption={(props, option) => {
                  return (
                    <span
                      {...props}
                      style={{
                        fontSize: "12px",
                        overflowWrap: "break-word",
                        width: "100%",
                      }}
                    >
                      {option.name}
                    </span>
                  );
                }}
                sx={{ width: 220, paddingTop: "6px" }}
                onChange={(e, value) => handleSelectedCity(e, value)}
                size="small"
                renderInput={(params) => (
                  <TextField
                    // style={{ border: "none" }}
                    {...params}
                    // onKeyPress={(e) => {
                    //   medicineNameInvalidChar(e);
                    // }}
                    size="small"
                    placeholder=""
                    // variant="standard"
                    InputProps={{
                      ...params.InputProps,
                      // disableUnderline: true,
                      // style: { fontSize: "12px", color: `${item.color}` },
                    }}
                    onChange={(e) => handleAutocomplete(e)}
                  />
                )}
                // renderInput={(params) => (
                //   <TextField
                //     {...params}
                //     onChange={(e) => handleAutocomplete(e)}
                //   />
                // )}
              />
            </Grid>
            <Grid xs={4} style={{ paddingLeft: "7px" }}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Last Appointment
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  size="small"
                  className="login-input"
                  id="outlined-start-adornment"
                  value={inputDetails.lastappointmentdate}
                  disabled
                />
              </FormControl>
            </Grid>
          </Grid>
          {/* 6th row */}

          <Grid
            item
            xs={12}
            style={{
              backgroundColor: "white",
              width: "100%",
              display: "inline-flex",
              padding: "10px",
              paddingLeft: "10px",
              flexDirection: "row",
              flexWrap: "wrap",
              position: "relative",
              justifyContent: "center",
              alignContent: "space-between",
              placeContent: "space-between",
              paddingTop: "0px",
              marginLeft: "10px",
            }}
            direction="column"
          >
            <Grid xs={8}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Remarks
              </InputLabel>
              <FormControl variant="standard" sx={{ m: 1 }}>
                <TextField
                  className="login-input"
                  id="outlined-start-adornment"
                  sx={{ width: "52.5ch" }}
                  size="small"
                  multiline
                  maxRows={4}
                  value={inputDetails.remarks}
                  onChange={(e) => setEditDetails(e.target.value, "remarks")}
                />
              </FormControl>
            </Grid>
            <Grid xs={4}>
              <InputLabel
                style={{
                  marginLeft: "7px",
                  fontFamily: "Lato",
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: 1.25,
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#7d7d7d",
                  width: "100%",
                }}
                htmlFor="input-with-icon-adornment"
              >
                Status
              </InputLabel>
              <FormControl
                variant="standard"
                sx={{ m: 1 }}
                // style={{ width: "100%" }}
              >
                {/* <TextField
                  className="login-input"
                  id="outlined-start-adornment"
                  size="small"
                  value={inputDetails.mode}
                  onChange={(e) => setEditDetails(e.target.value, "mode")}
                /> */}
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={inputDetails.status}
                  // label="Mode"
                  // onChange={handleChange}
                  onChange={(e) => setEditDetails(e.target.value, "status")}
                  size="large"
                  sx={{ minWidth: 220 }}
                  // style={{ background: "yellow", width: "100%" }}
                >
                  {/* <MenuItem value={"Tech Team"}>Assigned To Tech</MenuItem> */}
                  <MenuItem value={"Cancelled"}>Cancel</MenuItem>
                  <MenuItem value={"Open"} disabled>
                    Open
                  </MenuItem>
                  <MenuItem value={"Pending"} disabled>
                    Pending
                  </MenuItem>
                  <MenuItem value={"Closed"} disabled>
                    Closed
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid style={{ padding: "35px", textAlign: "right" }}>
          <Button
            variant="outlined"
            style={{ marginRight: "20px" }}
            onClick={() => closeAddModal()}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            style={{ color: "white" }}
            onClick={() => editDetails()}
          >
            Save
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};

export default AddDetailsModal;
